import React from 'react';
import NProgress from 'nprogress'
import 'nprogress/nprogress.css';
// import { withStyles } from '@mui/material/styles';
// import CircularProgress from '@mui/material/CircularProgress';
// import Grid from '@mui/material/Grid';

// const styles = theme => ({
//   progress: {
//     margin: theme.spacing.unit * 10,
//   },
// });

function Loader({}) {
    React.useEffect(() => {
        NProgress.configure({showSpinner: false, easing: 'ease', speed: 800});
        NProgress.start();

        return () => {
            NProgress.done();
        };
    });

    return '';
}

// Loader.propTypes = {
//     classes: PropTypes.object.isRequired,
// };
// withStyles(styles)(
export default Loader;
